import React from 'react'
import List from '../pages/list'

export const PagesCampusList = (props) => <List {...props} filter={{ collection: 'campus' }} title="Pages Campus" />

export default PagesCampusList
